import React, { useState, useCallback } from "react";
import { Button, Input, InputOnChangeData, Segment } from "semantic-ui-react";

export const YouTubeDownloader = () => {
  const [code, setCode] = useState("");
  const handleClick = useCallback(async () => {
    const res = await fetch(`/api/YouTube/download?code=${code}`);
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${code}.mp3`;
    link.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 1000);
  }, [code]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
      setCode(data.value);
    },
    []
  );

  return (
    <Segment inverted>
      <Input onChange={handleChange} label="Code" />
      <Button onClick={handleClick}>Submit</Button>
    </Segment>
  );
};
